export default __webpack_public_path__ + "static/media/whalar.5d291505.svg";